<div class="table-filters">
    <div class="filter-button" (click)="openFilterMenu()">
        <app-custom-icon
            [iconPath]="'assets/icons/general-icons.svg'"
            [imageName]="'filter'"
            [imageSize]="'18'">
        </app-custom-icon>
        <span>Filter</span>
    </div>
    @for (filter of currentFilters | keyvalue; track filter.key) {
        @if (isDisplayable(filter)) {
            @switch (filter.key) {
                @case ('title') {
                    <app-topbar-filter-button
                        [filter]="filter"
                        [dataToDisplay]="'Form Title: ' + filter.value"
                        (resetClicked)="resetFilter(filter.key)"></app-topbar-filter-button>
                }
                @case ('type') {
                    <app-topbar-filter-button
                        [filter]="filter"
                        [dataToDisplay]="filter.value | getFilterList:typeList:'type':'types'"
                        (resetClicked)="resetFilter(filter.key)"></app-topbar-filter-button>
                }
                @case ('category') {
                    <app-topbar-filter-button
                        [filter]="filter"
                        [dataToDisplay]="filter.value | getFilterList:categoryList:'category':'categories'"
                        (resetClicked)="resetFilter(filter.key)"></app-topbar-filter-button>
                }
                @case ('industries') {
                    <app-topbar-filter-button
                        [filter]="filter"
                        [dataToDisplay]="filter.value | getFilterList:industryList:'industry':'industries'"
                        (resetClicked)="resetFilter(filter.key)"></app-topbar-filter-button>
                }
                @case ('owner') {
                    @if (isAdmin$ | async) {
                        <app-topbar-filter-button
                            [filter]="filter"
                            [dataToDisplay]="'Owner: ' + (filter.value | findInList:ownerList)?.label"
                            (resetClicked)="resetFilter(filter.key)"></app-topbar-filter-button>
                    }
                }
            }
        }
    }
</div>
